import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  // Desktop View
  linkBox: {
      display: "flex",
      justifyContent: "flex-start",
      marginTop: "2%",
      marginLeft: "5%",
      marginBottom: "48px",
      height: "24px",
      width: "100%",
  },
  mainContent: {
    justifyContent: "center",
    margin: "0 auto",
  },
  title: {
    display: "flex",
    justifyContent: "center",
  },
  subContent: {
    display: "flex",
    justifyContent: "center",
    marginTop: "5%",
    marginBottom: "5%",
  },

  // Mobile Styling Below

  linkBoxMobile: {
    width: "100%",
    margin: "40px 0px",
    marginLeft: "8%",
  },
  mainContentMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 auto",
  },
  mobileTitle: {
    marginBottom: "30px",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "28px",
  },
  mobileSubContent: {
    justifyContent: "center",
  },
  mobileCardContainer: {
    marginTop: "48px",
    marginBottom: "80px",
  },

  // Universal for Desktop and Mobile View
  arrowImage: {
    position: "relative",
    width: "27px",
    height: "24px",
    marginRight: "8px",
  },
}));

export default useStyles;
